import axios from "axios";

const GET_API_URL  = process.env.REACT_APP_CONFIGURL;
const SET_API_URL = process.env.REACT_APP_BASEURL;

  
const headers =  { 
  'Content-Type': 'application/json',
  'token': localStorage.getItem("session-id")
}
  
const getConfiguration = (sessionID) => {
  var payload = {
    functionName: "GetConfigurations",
    postData: {},
  }
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(GET_API_URL, payload, {headers});
};

const setConfiguration = (sessionID,payload) => {
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(SET_API_URL, payload, {headers});
};

const verifySensitiveInfoPassword = (sessionID, password) => {
  const headers = {
    'Content-Type': 'application/json',
    'token': sessionID
  }
  return axios.post(SET_API_URL, {
    functionName: "VerifySensitiveInfoPassword",
    postData: { password },
  }, { headers });
};

const ConfigurationService = {
  getConfiguration,
  setConfiguration,
  verifySensitiveInfoPassword,
};
  
export default ConfigurationService;
